import { Flex } from '@eleveo/components-react';
import clsx from 'clsx';
import React from 'react';

type CenterProps = {
  children: React.ReactNode;
  className?: string;
};

export const Center = ({ children, className }: CenterProps) => (
  <Flex column alignItems="center" justifyContent="center" className={clsx('min-h-full', className)}>
    {children}
  </Flex>
);
